"use client";

import {IoIosContact} from "react-icons/io";
import CWFButton from "@/components/ui/CWFButton";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import {useRouter} from "next/navigation";
import toast from "react-hot-toast";

export default function FriendAction({isFriend, friendId,userId, accepted}){

    const axios = useAxiosAuth();
    const router = useRouter();
    function addFriend(){
        axios.post('contacts', {friend_id : friendId})
            .then(() => toast.success("Contact ajouté avec succès."))
            .catch(() => toast.error("Une erreur est survenue"))
            .finally(() => router.refresh());
    }

    function removeFriend(){
        axios.delete(`contacts/${friendId}`)
            .then(() => toast.success("Contact retiré avec succès"))
            .catch(() => toast.error("Une erreur est survenue."))
            .finally(() => router.refresh())
    }
    if(parseInt(friendId) === userId){
        return <></>
    }
    if(isFriend){
        if(accepted !== 2 )
        {
            return(
                <CWFButton className={"flex gap-x-2"} variant={'destructive'} onClick={removeFriend}>
                    <IoIosContact />
                    {accepted === 0
                        ?
                        "Demande en attente"
                        :
                        "Retirer de mes contacts"
                    }

                </CWFButton>
            )
        }else{
            return <></>
        }

    }else{
        return(
            <CWFButton className={"flex gap-x-2"} onClick={addFriend}>
                <IoIosContact />
                Ajouter aux contacts
            </CWFButton>
        )
    }


}